import { colors } from "@constants/theme";
import React, { RefObject } from "react";
import { View, TextInput, Pressable, StyleSheet } from "react-native";
import SearchIcon from "@assets/svg/SearchIcon";
import Cross from "@assets/svg/Cross";

interface SearchFieldProps {
  searchPlaceholder: string;
  onSearchInputChange: (text: string) => void;
  searchText: string;
  onPressCrossIcon: () => void;
  textInputRef: RefObject<TextInput>;
  testID?: string;
  setSearchText?: (text: string) => void;
  hideShadow?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({
  searchPlaceholder,
  onSearchInputChange,
  searchText,
  onPressCrossIcon,
  textInputRef,
  testID = "",
  setSearchText = () => {},
}) => {
  return (
    <View style={styles.searchBar}>
      <SearchIcon style={styles.searchIcon} />
      <TextInput
        ref={textInputRef}
        testID={testID}
        placeholder={searchPlaceholder}
        placeholderTextColor={colors.mediumBlacklightBlack}
        cursorColor={colors.mediumBlacklightBlack}
        returnKeyType="done"
        style={styles.searchInput}
        onChangeText={(text) => {
          setSearchText && setSearchText(text);
          onSearchInputChange(text);
        }}
      />
      {searchText.length > 0 ? (
        <Pressable
          onPress={() => {
            if (textInputRef.current) {
              textInputRef.current.clear();
            }
            onPressCrossIcon();
            setSearchText && setSearchText("");
          }}
          testID="searchIcon"
          style={styles.crossIconContainer}
        >
          <Cross height={15} width={15} />
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  searchContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 12,
    borderRadius: 20,
    elevation: 5,
    backgroundColor: "white",
    borderColor: "rgba(229, 229, 229, 1)",
    borderWidth: 0.5,
    justifyContent: "space-between",
    paddingRight: 12,
    marginRight: 12,
  },
  searchInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  searchInput: {
    flex: 1,
    fontSize: 12,
    fontWeight: "400",
    height: 40,
  },
  crossIconContainer: {
    padding: 5,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 12,
    paddingHorizontal: 16,
    borderRadius: 20,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.blank_grey,
    height: 35,
    flex: 1,
  },
  searchIcon: {
    marginRight: 8,
  },
});

export default SearchField;
